"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedQueryWrapper = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const react_1 = tslib_1.__importDefault(require("react"));
const reselect_1 = require("reselect");
const shallowequal_1 = tslib_1.__importDefault(require("shallowequal"));
const PaginatedRowStore_1 = require("../dataGrid/PaginatedRowStore");
const GraphQLSliceable_1 = require("./GraphQLSliceable");
/**
 * TODO: deprecate this consider using the pagination api in apollo https://www.apollographql.com/docs/react/pagination/core-api
 * The PaginatedQueryWrapper is a provider component that gives its children access to a paginated GraphQL query.
 */
class PaginatedQueryWrapper extends react_1.default.Component {
    constructor() {
        super(...arguments);
        /*
         * We use a custom memoizer for the row store that extracts the partial query variables from the props
         * and checks shallow equality on them separately, so that if the client passes in a new object
         * containing the same query variables, we don't obliterate the previous row store.
         */
        this.memoizedCreateRowStore = (0, reselect_1.defaultMemoize)(createRowStore, (a, b) => (0, shallowequal_1.default)(a, b));
    }
    render() {
        return (react_1.default.createElement(client_1.ApolloConsumer, null, (client) => {
            const _a = this.props, { children, partialQueryVariables } = _a, rowFetcherParams = tslib_1.__rest(_a, ["children", "partialQueryVariables"]);
            const rowStore = this.memoizedCreateRowStore(rowFetcherParams, partialQueryVariables, client);
            return children({ rowStore });
        }));
    }
}
exports.PaginatedQueryWrapper = PaginatedQueryWrapper;
function createRowStore(sliceableFactoryParams, partialQueryVariables, client) {
    const queryRows = (0, GraphQLSliceable_1.makeRowFetcher)(sliceableFactoryParams, partialQueryVariables, client);
    return new PaginatedRowStore_1.PaginatedRowStore(queryRows);
}
//# sourceMappingURL=PaginatedQueryWrapper.js.map